export const isFieldEditable = (fieldId: string) => fieldId.split('_')[0] === 'customfield';
